import React from "react";

import * as Components from "../../components";

export interface UserCheckProps {
    yumSSOId: string
    helpDescEmail: string
    onVerify: (isApproved: boolean) => void
    onBackToLogin: () => void
}

export const UserCheck: React.FunctionComponent<UserCheckProps> = (props) => {
    const [userName, setUsername] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");
    const [validationErrorMessage, setValidationErrorMessage] = React.useState<string | null>(null)
    const [showBackToLogin, setShowBackToLogin] = React.useState(false);
    const [contactHelpDesc, setContactHelpDesc] = React.useState(false);
    const onSubmit = () => {
        if (!Boolean(userName?.length)) {
            setValidationErrorMessage("Tracks username is required");
            return;
        }
        if (!Boolean(password?.length)) {
            setValidationErrorMessage("Tracks password is required");
            return;
        }

        fetch("YumSSOSelfService/AssociateWihhYumId", {
            method: "Post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                TracksUserName: userName,
                TracksPassword: password
            })
        }).then(async (response) => {
            debugger
            if (response.status === 200)
                props.onVerify(true)
            else if (response.status === 400) {
                let data = await response.json();

                if (data.Error === "failed")
                    props.onVerify(false)
                else if (data.Error === "account-locked") {
                    setShowBackToLogin(true)
                    setValidationErrorMessage(data.ErrorDescription);
                    setContactHelpDesc(true);
                }
                else
                    setValidationErrorMessage(data.ErrorDescription)
            } else {
                props.onVerify(false)
            }
        }).catch(() => {
            props.onVerify(false)
        })
    }


    return <Components.LayoutBlock fill>
        <Components.LayoutBlock>
            <Components.LayoutBlock fill className="yum-sso-self-service-message">
                <div style={{ display: "inline" }}>To associate Yum ID "{props.yumSSOId}" with a Tracks profile, please enter <span style={{ display: "inline", fontWeight: 600 }}>Tracks username and password</span>
                </div>
            </Components.LayoutBlock>
            <Components.LayoutBlock >
                <form>

                </form>
                <Components.Textbox
                    icon={{ icon: 'user' }}
                    placeholder='Tracks Username'
                    onChange={setUsername}
                    readonly={showBackToLogin}
                    onSubmit={onSubmit}
                    value={userName}
                />
                <Components.Textbox
                    icon={{ icon: 'lock' }}
                    placeholder='Tracks Password'
                    type="password"
                    readonly={showBackToLogin}
                    onChange={setPassword}
                    onSubmit={onSubmit}
                    value={password}
                />
                <div style={{ color: "red", textAlign: "left", fontSize: 14, lineHeight: 1.5 }}>
                    <div>{validationErrorMessage}</div>
                    {contactHelpDesc && <div>Please contact {props.helpDescEmail}</div>}
                </div>
            </Components.LayoutBlock>
        </Components.LayoutBlock>
        {
            !showBackToLogin &&
            <Components.Button onClick={onSubmit} style={{ marginTop: 24 }}>
                Submit
            </Components.Button>
        }
        {
            showBackToLogin &&
            <Components.Button onClick={props.onBackToLogin} style={{ marginTop: 24 }}>
                Back To Login
            </Components.Button>
        }
    </Components.LayoutBlock>
}